import { join, filter } from 'lodash'
import Decorator from './decorator'
import moment from 'moment'

export default class TruckDecorator extends Decorator {
  /**
   * Get the URL to the trucks thumbnail.
   *
   * @return string
   */
  thumbnailUrl () {
    if (this.decorated.photo_storage_path) {
      return `${this.decorated.photo_storage_path}/256x256.jpg?${moment().unix()}`
    }

    return null
  }

  makeAndModel () {
    return join(filter([this.decorated.make, this.decorated.model]), ' - ')
  }
}



// WEBPACK FOOTER //
// ./src/decorators/truck.js